export default __webpack_public_path__ + "static/media/4.0cb30b14.webp";